import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {downloadFileByPedidos} from '../utils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const reportBoList = (dateFrom, dateTo, ruc) => apiActionCreator({
  'endpoint': `/boReport/${dateFrom}/dateFrom/${dateTo}/dateTo/${ruc}/ruc`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_REPORT_BO,
    ActionTypes.FETCHED_REPORT_BO,
    [
      ActionTypes.FETCHED_REPORT_BO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const reportBoListExcel = (dateFrom, dateTo, ruc) => apiActionCreator({
  'endpoint': `/boReport/excel/${dateFrom}/dateFrom/${dateTo}/dateTo/${ruc}/ruc`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_REPORT_BO_EXCEL,
    ActionTypes.FETCHED_REPORT_BO_EXCEL,
    [
      ActionTypes.FETCHED_REPORT_BO_EXCEL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const deleteBoReport = (data) => ({
  'type': ActionTypes.DELETE_BO_REPORT,
});

export const deleteBoReportURL = (data) => ({
  'type': ActionTypes.DELETE_BO_REPORT_URL,
});

export const reportBoByOrdersList = (dateFrom, dateTo, rucs, type) => apiActionCreator({
  'endpoint': `/boReport/byOrders/${dateFrom}/dateFrom/${dateTo}/dateTo/${rucs}/ruc/${type}/type`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_REPORT_BY_ORDERS_BO,
    [
      (response) => {
        downloadFileByPedidos(response.data, type);
        return {
          'type': ActionTypes.FETCHED_REPORT_BY_ORDERS_BO,
        };
      },
      () => MessageActions.addMessageBoxInfo('Archivo generado correctamente'),
    ],
    [
      ActionTypes.FETCHED_REPORT_BY_ORDERS_BO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
